<template>
  <article class="Wdgt-Content" ref="widget">
    <ContentHeader class="Wdgt-Content__hdr" :post="get_post" @goToComments="goToCommentsSection"/>
    <ContentTitle
      class="Wdgt-Content__ttl"
      :post="get_post"
      :type="get_isAlpha ? 'alpha' : get_isNews ? 'news' : 'other'"/>
    <div class="Wdgt-Content__content Wdgt-Content-Html" v-html="get_content" @click="handleClickToContent"></div>
    <template v-if="get_hasPaidAccount">
      <!-- <ContentPodcast class="Wdgt-Content__content" :podcast="get_podcastData" v-if="get_isPodcast"/> -->
      <InnerPageAudioPlayer class="Wdgt-Content__content" :idPodcast="get_podcastData.id" v-if="get_isPodcast" />
      <OpinionImages class="Wdgt-Content__opinion-images" :post="get_post" v-if="get_isShowOpinionImagesList"/>
      <ExternalModule class="Wdgt-Content__external-modules" :post="get_post" v-if="get_isShowExternalModule"/>
      <div class="Wdgt-Content__reactions">
        <ContentReactions :postId="get_idPost"/>
      </div>
      <ContentComments class="Wdgt-Content__content-comments" :commentsPlace="props.commentsPlace" :postId="get_idPost" ref="comments"/>
      <div class="Wdgt-Content__separator" v-if="get_isShowSimilar && get_isShowLastCommentsTtl && hasSimilarPosts">
        <div class="Wdgt-Content__separator__line"></div>
      </div>
      <SimilarPosts
        class="Wdgt-Content__similar-posts"
        :post="get_post"
        :isAlpha="get_isAlpha"
        v-if="get_isShowSimilar"
        @update-has-posts="updateSimilarPostsState"/>
      <!-- <OtherPodcasts class="Wdgt-Content__similar-podcasts" v-if="get_isPodcast"/> -->
    </template>

    <OtherPodcasts class="Wdgt-Content__other-podcasts" v-if="get_isPodcast && get_hasPaidAccount" />
  </article>
</template>

<script setup>
import {computed, defineProps, nextTick, onBeforeMount, onBeforeUnmount, onMounted, ref} from 'vue';
import {Props} from './scripts/props.js';
import {useStore} from 'vuex';
import {useRouter} from 'vue-router';
import {PATHS_NAME} from '@shared/routers/consts/pathsName';
import {initLazyLoadObserver} from '@shared/utils/images/lazyLoad.js';
import {POST_TYPES} from '@shared/constants/posts/postTypes.js';
import {postViewCountUpdate} from '@shared/api/posts/postViewCountUpdate';
import { sliderImageDisplay } from '@/Groups/Slider/public/utils/callSlider.js';
import { usePodcastManager } from '@/Groups/Audioplayer/public/utils/podcastsData.js';
import DROPDOWN_NAMES from '@shared/constants/dropdowns/dropdownsName';
//-----------------------------
import CapitalInfo from '@widgets/ContentWidget/general/CapitalInfo/CapitalInfo.vue';
import ContentHeader from './components/Header/ContentHeader.vue';
import ContentTitle from './components/Title/ContentTitle.vue';
import ContentComments from '@widgets/ContentWidget/general/Comments/ContentComments.vue';
import SimilarPosts from './components/SimilarPosts/SimilarPosts.vue';
import ContentReactions from '@widgets/ContentWidget/general/Reactions/ContentReactions.vue';
import OpinionImages from './components/OpinionImages/OpinionImages.vue';
import ExternalModule from './components/ExternalModule/ExternalModule.vue'
import InnerPageAudioPlayer from '@/Groups/Audioplayer/public/modules/InnerPageAudioPlayer/InnerPageAudioPlayer.vue';
import OtherPodcasts from '@/Groups/Audioplayer/public/modules/OtherPodcasts/OtherPodcasts.vue';
//-----------------------------
const store = useStore();
const router = useRouter();
const props = defineProps(Props());
//-----------------------------
const POPUP_NAME = DROPDOWN_NAMES.contentPage;
//-----------------------------
const comments = ref(null);
const widget = ref(null);
const observer = ref(null);
const hasSimilarPosts = ref(false);
//-----------------------------
const { addPodcastToStore } = usePodcastManager();
//-----------------------------
// Проверка существования похожих постов
const updateSimilarPostsState = (hasPosts) => {
  hasSimilarPosts.value = hasPosts;
};
//-----------------------------
onBeforeMount(() => {
  changeSrcToVLazy();
  addPodcastToStore(get_podcastData.value)
})
onMounted(async () => {
  if (get_isWidgetOpen.value) {
    window.addEventListener('keydown', handleF5Press);
    window.addEventListener('popstate', handlePopstate);
  }
  await nextTick();
  await initScrollPositon();
  await nextTick();
  initLazyLoadObserver(widget.value);
  observeCommentsVisibility();
  initSpoilers();
  useUpdatePostViews();
})
onBeforeUnmount(() => {
  window.removeEventListener('keydown', handleF5Press);
  window.removeEventListener('popstate', handlePopstate);
  if (observer.value) {
    observer.value.disconnect();
    observer.value = null;
  }
})
//-----------------------------
//Получить контекст объекта для комментариев
const get_commentsCtx = computed(() => {
  if (props.commentsPlace === 'popup') return 'popupComments';
  else if (props.commentsPlace === 'page') return 'contentPageComments';
});
//Открыт ли попап с контентом?
const get_isWidgetOpen = computed(() => store.getters['Dropdowns/isInList'](POPUP_NAME));
//Получить словарь альфа
const get_alpha = computed(() => store.state.ContentSystem.Alpha.list);
//Получить словарь инфошума
const get_news = computed(() => store.state.ContentSystem.Infonoise.list);
//Получить ID
const get_idPost = computed(() => {
  const path = window.location.pathname;
  const segments = path.split('/');
  return parseInt(segments[segments.length - 1]);
});
//Это из колонки инфошума
const get_isNews = computed(() => get_news.value.hasOwnProperty(get_idPost.value));
//Это из колонки альфа
const get_isAlpha = computed(() => get_alpha.value.hasOwnProperty(get_idPost.value));
//Получить объект для передачи
const get_post = computed(() => {
  if (get_isNews.value) return get_news.value[get_idPost.value];
  else if (get_isAlpha.value) return get_alpha.value[get_idPost.value];
});
//Пост является подкастом?
const get_isPodcast = computed(() => get_post.value.section_name === 'podcast');
//Пост является мнением?
const get_isOpinion = computed(() => get_post.value.model_name.toLowerCase() === POST_TYPES.OPINION);
//Отображать ли список изображений
const get_isShowOpinionImagesList = computed(() => get_post.value.images_list?.length > 0 && get_isOpinion.value);
//Получить контент
const get_content = computed(() => get_post.value.content || '');
//Получит объект подкаста
const get_podcastData = computed(() => get_post.value.podcast_atributes);
//Должен ли попап сопровождаться переходом к комментам
const get_isMoveToComment = computed(() => store.state.ContentSystem.Comments[get_commentsCtx.value].isScrollToComments);
//Пользователь не имеет доступа к закрытому контенту (нет платной подписки)
const get_hasPaidAccount = computed(() => store.getters['UserSystem/hasPaidAccess']);
//Отображать ли блок похожие посты?
const get_isShowSimilar = computed(() => !get_isPodcast.value);
//Отображать ли контентную часть
const get_isShowContent = computed(() => !get_isPodcast.value && get_hasPaidAccount.value);
//Отображать ли модуль с виджетами на внешние ресурсы
const get_isShowExternalModule = computed(() => get_post.value.embed_links?.length > 0);
//Получить список комментариев
const get_comments = computed(() => store.state.ContentSystem.Comments[get_commentsCtx.value].list);
//Отображать ли заголовок последних комментариев?
const get_isShowLastCommentsTtl = computed(() => get_comments.value?.length > 0);
//-----------------------------
//Определить позицию скролла при отображении компонента
const initScrollPositon = async () => {
  const urlParams = new URLSearchParams(window.location.search);
  const commentIdFromUrl = urlParams.get('comment_id');
  const idCommentScroll = store.state.ContentSystem.Comments[get_commentsCtx.value].targetCommentsId || commentIdFromUrl;
  if (get_isMoveToComment.value && !idCommentScroll) {
    goToCommentsSection('fast');
    toClearScrollTarget();
  }
}
//Очистить данные для перехода к комментариям
const toClearScrollTarget = () => {
  store.commit('ContentSystem/Comments/setScrollTarget', {
    isComments: null,
    idComment: null,
    context: get_commentsCtx.value
  });
}
//Закрыть попап с контентом, если при переходе он открыт
const toClosePopup = () => {
  store.dispatch('Dropdowns/removeTheDropdown', POPUP_NAME);
};
//Дейсвтия при нажатии на кнопку f5
const handleF5Press = (event) => {
  if (get_isWidgetOpen.value && (event.key === 'F5' || event.keyCode === 116 || event.which === 116)) {
    event.preventDefault();
    toClosePopup();
    store.commit('ContentSystem/Comments/clonePopupCommentsToPage');
    router.push({
      name: PATHS_NAME.ARTICLES,
      params: {id: get_idPost.value, type: get_post.value.model_name.toLowerCase()}
    });
  }
};
//Проскролить до секции с комментариями
const goToCommentsSection = () => {
  const scrollItem = comments.value?.$refs.contentComments;
  const scrollModal = document.querySelector('[data-content-scroll-wrapper]');
  const pageScroll = document.querySelector('[page-article]');
  if (!scrollItem) return;
  const rect = scrollItem.getBoundingClientRect();
  // Скролл в модалке или скролл на странице
  if (scrollModal) {
    const scrollPosition = scrollModal.scrollTop + rect.top;
    scrollModal.scrollTo({
      top: scrollPosition - 70,
      behavior: 'auto',
    });
  } else if (pageScroll) {
    const scrollPosition = window.scrollY + rect.top;
    window.scrollTo({
      top: scrollPosition - 70,
      behavior: 'auto',
    });
  }
};

//Дейсвтия при нажатии на кнопку назад в навигации для открытого попапа
const handlePopstate = () => toClosePopup();
//Клик по контентной области
const handleClickToContent = (e) => {
  if (e.target.tagName === 'IMG'){
    sliderImageDisplay(e.target.src);
  }
}
//Заменяем в картинках src на v-lazy (что бы скролл не сдвигался из-за подгурзки картинок)
const changeSrcToVLazy = () => {
  get_post.value.content = get_post.value.content.replace(/(<img\s+[^>]*?)\ssrc=/gi, '$1 v-lazy=');
}

//Создаем обесрвер чтобы определить, что comments block попал в область видимости
const observeCommentsVisibility = () => {
  const target = comments.value?.$el;
  if (!target) return;
  observer.value = new IntersectionObserver(
    ([entry]) => {
      if (!entry.isIntersecting) return;
      toUpdateNewCommentsCounter();
    },
    {root: null, rootMargin: '0px', threshold: 0.1,}
  );
  observer.value.observe(target);
};
//Обновить счетчик новых комментариев
const toUpdateNewCommentsCounter = () => {
  const areaName = get_isAlpha.value ? 'Alpha' : 'Infonoise';
  store.commit(`ContentSystem/${areaName}/toUpdateNewCommentsCounter`, {id: get_idPost.value});
}
//Удалить текущий список комментариев
const removeComments = () => {
  store.commit('ContentSystem/Comments/clearList', {context: get_commentsCtx.value});
}
//-----------------------------
// Инициализация спойлеров
const initSpoilers = () => {
  const contentElement = widget.value.querySelector(".Wdgt-Content__content");
  if (!contentElement) return;

  const spoilers = contentElement.querySelectorAll('[x-data="spoilerBlock()"]');
  spoilers.forEach((spoiler) => {
    const cape = spoiler.querySelector(".spoiler-block__cape");
    const arrow = spoiler.querySelector(".spoiler-block__arrow");

    if (cape) cape.classList.add("spoiler-block__cape--disable");
    if (arrow) arrow.classList.remove("spoiler-block__arrow--rotate");

    spoiler.addEventListener("click", (event) => {
      const isArrow = event.target.closest('.spoiler-block__arrow');

      if (spoiler.classList.contains('open') && isArrow) {
        closeSpoiler(spoiler);
      } else {
        openSpoiler(spoiler);
      }
    });
  });
};
// Переключение состояний спойлера
const openSpoiler = (spoiler) => {
  if (!spoiler.classList.contains('open')) {
    spoiler.classList.add('open');

    const cape = spoiler.querySelector(".spoiler-block__cape");
    const arrow = spoiler.querySelector(".spoiler-block__arrow");

    cape?.classList.remove("spoiler-block__cape--disable");
    arrow?.classList.add("spoiler-block__arrow--rotate");
  }
};
const closeSpoiler = (spoiler) => {
  if (spoiler.classList.contains('open')) {
    spoiler.classList.remove('open');

    const cape = spoiler.querySelector(".spoiler-block__cape");
    const arrow = spoiler.querySelector(".spoiler-block__arrow");

    cape?.classList.add("spoiler-block__cape--disable");
    arrow?.classList.remove("spoiler-block__arrow--rotate");
  }
};

//Обновление счетчика просмотров
const useUpdatePostViews = async () => {
  try {
    await postViewCountUpdate(get_post.value);
  } catch (error) {
    console.error('Failed to update post views:', error);
    throw error;
  }
};
</script>

<style lang="scss">
@import './styles/_conf';
</style>
